module.exports = __webpack_public_path__ + "static/media/about_2.cee26c1a.svg";